import styled from "styled-components"
import {
  Button
} from 'components/common'
import {
  CopyContainer
} from 'linkdrop-ui'

export const ReclaimContainer = styled.div`

`


export const ButtonStyled = styled(Button)`

`

export const CopyContainerStyled = styled(CopyContainer)`
  margin-bottom: 32px;
  max-width: 412px;
  h3 {
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 8px;
  }
`